export enum ENodeType {
  Table = 'Table',
  Divider = 'Divider',
  Image = 'Image',
  Text = 'Text',
}

export enum EDividerType {
  Dashed = 'Dashed',
  Thin = 'Thin',
  Thick = 'Thick',
}

export enum EImageSize {
  Full = 'Full',
  Half = 'Half',
  Original = 'Original',
  Cover = 'Cover',
}
